"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        Globalize.addCultureInfo("en", {
            messages: {
                Product_IsPreview: "Preview",
                Product_IsPreviewDescription: "You're currently running a preview version of the service.",
                User_CompanyFormat: "({0}) {1}",
                User_SignOut: "Sign out",
            }
        });
        var UserDefaults = {
            Alias: "",
            AppVersion: "",
            BrandingLicense: "",
            ClientConnectivityEnabled: null,
            ClientFlightInformation: "",
            ClientId: null,
            Company: "",
            CompanyName: "",
            DefaultNavPaneView: null,
            Density: $dyn.densityThemeManager._getDefaultDensity(),
            DismissNotification: null,
            EnhancedTabSequence: false,
            ExecuteNotificationAction: null,
            ImageName: "Person",
            ImageType: "Symbol",
            Locale: "",
            MaxWaitTimeToFailInMinutes: null,
            OperatedBy: "",
            Partition: "",
            PlatformVersion: "",
            ProductIsPreview: null,
            RedirectToDashboard: false,
            RegionalSettings: "",
            RequestCompanyChange: "",
            RequestedSessionNotFound: false,
            SessionExpireAutoLogoff: null,
            SetCompany: null,
            ShowOnNavBar: null,
            SkypeEnabled: null,
            Startpage: "",
            Theme: $dyn.densityThemeManager._getDefaultTheme(),
            TimeZoneRules: "",
            TooltipOnFocus: false,
            UserGuid: null,
            UserName: "",
            UserSessionDate: "",
            WebClientStatefulSessionTimeoutInSeconds: null,
        };
        $dyn.ui.defaults.User = UserDefaults;
        var User = /** @class */ (function (_super) {
            __extends(User, _super);
            function User(data, element, parent, role) {
                var _this = _super.call(this, data, element, parent, role) || this;
                /**
                 * Provide hook to open while in an overflow menu.
                 */
                _this.Click = function () {
                    _this.UserFlyoutVisible(true);
                };
                _this.UserVisible = function () {
                    if (_this.UserFlyoutVisible()) {
                        $(document.body).on("resetShellOnNavigation.dynNavigationBarUser", function () {
                            _this.UserFlyoutVisible(false);
                        });
                    }
                    else {
                        $(document.body).off("resetShellOnNavigation.dynNavigationBarUser");
                    }
                };
                _this.updateTimeZoneRules = function (newRules) {
                    if ($dyn.value(newRules)) {
                        moment.tz.add($dyn.value(newRules));
                    }
                };
                _this.updateRegionalSettings = function (value) {
                    // Find the key (which may be different than the name) for the current culture
                    // in the Globalize cultures dictionary
                    var getCurrentCultureKey = function () {
                        var currentCulture = Globalize.culture();
                        var currentCultureKey = Globalize.culture().name;
                        for (var key in Globalize.cultures) {
                            if (Globalize.cultures.hasOwnProperty(key)) {
                                if (Globalize.cultures[key] === currentCulture) {
                                    currentCultureKey = key;
                                    break;
                                }
                            }
                        }
                        return currentCultureKey;
                    };
                    var newSettings = $dyn.value(value);
                    if (newSettings) {
                        // Update the current Globalize culture based on the settings from the server.
                        var localeInfo = JSON.parse(newSettings);
                        // In Globalize v0.1.0a2, if a culture name is passed in to Globalize.addCultureInfo(), it will be used as a key
                        // to index into its cultures array. If a culture name is not passed in,  it will use the current culture name.
                        // Since the culture name is not necessarily the same as the key being used for it, it could update the wrong culture,
                        // therefore we pass in the current culture key to ensure the current culture is the one being updated.
                        Globalize.addCultureInfo(getCurrentCultureKey(), {
                            calendar: {
                                "/": localeInfo.dateSeparator,
                                ":": localeInfo.timeSeparator,
                                firstDay: localeInfo.firstDayOfWeek,
                                patterns: {
                                    d: localeInfo.shortDate,
                                    t: localeInfo.shortTime,
                                    T: localeInfo.shortTime
                                },
                            },
                            numberFormat: {
                                "+": localeInfo.positiveSign,
                                ",": localeInfo.thousandsSeparator,
                                "-": localeInfo.negativeSign,
                                ".": localeInfo.decimalSeparator,
                                decimals: localeInfo.decimals,
                                pattern: [localeInfo.pattern]
                            }
                        });
                        // since we get regional settings after timeSeparators is setup - we need to reset again
                        $dyn.util.timeSeparators.auto = localeInfo.timeSeparator ? localeInfo.timeSeparator : " ";
                        var is24HourCultureDefault = localeInfo.shortTime.indexOf("H") !== -1;
                        var timeFormatPattern = void 0;
                        if (is24HourCultureDefault) {
                            timeFormatPattern = "HH" + localeInfo.timeSeparator + "mm";
                        }
                        else {
                            timeFormatPattern = "hh" + localeInfo.timeSeparator + "mm A";
                        }
                        var localSpecification = { longDateFormat: { LT: timeFormatPattern } };
                        moment.updateLocale(moment.locale(), localSpecification);
                        // Update the control library culture settings
                        if ($dyn.util.isFlightEnabled($dyn.reactGrid.featureName)) {
                            $dyn.shell.setControlLibraryCultureSettings();
                        }
                    }
                };
                _this.updateClientFlight = function (value) {
                    var newFlights = $dyn.value(value);
                    if (newFlights) {
                        // Update the current Flight information based on the settings from the server.
                        _this.FlightingFlags(JSON.parse(newFlights));
                    }
                    if (!$dyn.util.isFlightEnabled("LegacyNavBar")) {
                        var navBar = $dyn.ui.getNavBar();
                        // is this limited navigation
                        if (navBar) {
                            if (navBar.OfficeNavBarVisible) {
                                navBar.OfficeNavBarVisible(true);
                            }
                            else if ($dyn.restrictedNavigation) {
                                navBar.element.classList.add("officeNavBar");
                            }
                        }
                    }
                    // special boot strap case for static loader
                    $dyn.serverForm.compilation.StaticLoader.staticLoaderOn = ($dyn.debug.staticLoaderOn || $dyn.flags.useDesignTimeView) ? true : $dyn.util.isFlightEnabled("StaticLoaderOn");
                    if ($dyn.util.isFlightEnabled($dyn.reactGrid.featureName)) {
                        $dyn.shell.loadControlLibraryResources();
                    }
                };
                _this.updateOperatedByName = function (value) {
                    $dyn.shell.OperatedByName($dyn.value(value));
                };
                _this.updateBrandingNameItems = function (value) {
                    var brandLicense = $dyn.value(value);
                    var skuColor = {
                        D365_Finance: "#054C13",
                        D365_Retail: "#7F4209",
                        D365_SCM: "#1F416E",
                    };
                    var brandData = JSON.parse(brandLicense);
                    var shortName = brandData.ProductShortName;
                    var productName = brandData.ProductBrandingName;
                    var skuName = brandData.ProductSKU;
                    // set the short name from Branding name
                    if (shortName && !$dyn.shell.ProductShortName()) {
                        // update elements that rely on the short name
                        $dyn.shell.updateProductNameItems(shortName);
                    }
                    // update product long name
                    if (productName && !$dyn.shell.ProductName()) {
                        $dyn.shell.ProductName(productName);
                    }
                    if (skuName) {
                        if ($dyn.appConfig) {
                            if ($dyn.appConfig["msapplication-tooltip"] && productName) {
                                $dyn.htmlDocument.setMetaValue("msapplication-tooltip", "Launch " + productName, "");
                            }
                            if (!$dyn.shell.FavIconUrl) {
                                // update icons and other elements based on skuName
                                if ($dyn.appConfig.images.favIconUrl && $dyn.appConfig.images.favIconName) {
                                    $dyn.shell.FavIconUrl = $dyn.appConfig.images.favIconUrl + "/" + skuName + "/" + $dyn.appConfig.images.favIconName;
                                    $dyn.htmlDocument.setFavicon($dyn.shell.FavIconUrl);
                                }
                                else {
                                    $dyn.log("Failed to set FavIconUrl - either name or url was missing");
                                }
                            }
                            // set up tile images only if the image path is not defined
                            if ($dyn.appConfig.images && $dyn.appConfig.images.tileImagesUrl) {
                                // meta and link tags
                                if ($dyn.appConfig.images["msapplication-TileImage"]) {
                                    $dyn.htmlDocument.setMetaValue("msapplication-TileImage", $dyn.appConfig.images["msapplication-TileImage"], $dyn.appConfig.images.favIconUrl + "/" + skuName + "/");
                                    // set color if found
                                    if (skuColor[skuName]) {
                                        $dyn.htmlDocument.setMetaValue("msapplication-TileColor", skuColor[skuName], "");
                                        $dyn.htmlDocument.setMetaValue("msapplication-navbutton-color", skuColor[skuName], "");
                                    }
                                }
                                if ($dyn.appConfig.images["apple-touch-icon"]) {
                                    $dyn.htmlDocument.setLinkIconValue("apple-touch-icon", $dyn.appConfig.images["apple-touch-icon"], $dyn.appConfig.images.favIconUrl + "/" + skuName + "/");
                                }
                            }
                            else {
                                $dyn.log("Failed to set tileImages - url was missing");
                            }
                        }
                        else {
                            $dyn.log("Undefined or null appConfig");
                        }
                    }
                };
                /**
                 * Close all forms and then open a new Dashboard in the current session company context.
                 */
                _this.NavigateToDashboard = function () {
                    if ($dyn.value(_this.RedirectToDashboard)) {
                        $dyn.async(function () {
                            _this.RedirectToDashboard._current = false;
                            $dyn.shell.closeAllFormsBeforeNavigating($dyn.shell.goHome);
                        }, undefined, "doRedirectToDashboard");
                    }
                };
                _this.RestoreServerSession = function () {
                    if ($dyn.value(_this.RequestedSessionNotFound)) {
                        $dyn.async(function () {
                            if ($dyn.serverForm) {
                                var defaultChannel = $dyn.serverForm.defaultChannel();
                                if (defaultChannel && defaultChannel.channel && defaultChannel.channel.serverSessionId) {
                                    // End any other sessions besides the one we are attempting restore
                                    $dyn.serverForm.endSession(defaultChannel.channel.serverSessionId);
                                }
                                $dyn.shell.cleanWindowFormsBeforeNavigating($dyn.serverForm.restoreCurrentSession);
                            }
                        }, undefined, "Cleaning client side form objects before requesting a server session restore.");
                    }
                };
                /**
                 * Close all forms, set the session company context to the requested value,
                 * and then reopen the most recently opened root navigable form.
                 */
                _this.CloseFormsThenChangeCompany = function () {
                    if ($dyn.value(_this.RequestCompanyChange)) {
                        $dyn.async(function () {
                            var destinationCompany = $dyn.value(_this.RequestCompanyChange);
                            _this.RequestCompanyChange._current = "";
                            var newForm = $dyn.serverForm.initialForm();
                            // if initialForm returns the defaultForm, it comes with parameters we don't want
                            // (the parameters would prevent automatically opening the form after it is created).
                            newForm.targetElement = undefined;
                            newForm.context = undefined;
                            // Update the URL Query string when we write the browser history,
                            newForm.updateQuery = true;
                            // Close all forms before loading the new form.
                            $dyn.shell.closeAllFormsBeforeNavigating(function () {
                                $dyn.shell.createForm(newForm);
                            }, {
                                closeDashboard: true,
                                destinationCompany: destinationCompany,
                                retainCrumb: true
                            });
                        }, undefined, "doCloseFormsThenChangeCompany");
                    }
                };
                $dyn.ui.applyDefaults(_this, data, $dyn.ui.defaults.User);
                _this.FlightingFlags = $dyn.observable();
                _this.UseAvatarImage = $dyn.observable(false);
                _this.UseAvatarInitials = $dyn.observable(true);
                _this.UserAvatar = $dyn.observable("");
                _this.UserAvatarComplete = $dyn.observable(false);
                _this.UserInitials = $dyn.observable("");
                _this._language = $dyn.observable("");
                _this.Language = data.Language = $dyn.computed(function () {
                    return $dyn.value(_this._language);
                }, function (value) {
                    // Once set the language can not be changed, the browser needs to be refreshed to change the language
                    if (!$dyn.value(_this._language)) {
                        _this._language(value);
                    }
                    else {
                        $dyn.logWarning('Language already set: current="%s", requested: "%s"', _this._language, value);
                    }
                });
                // Deliverable 160434: User option to enable/disable display of user/company button in Nav Bar when Nav Pane is collapsed
                _this.ShowOnNavBar(true);
                _this.DefaultNavPaneView(2);
                _this.UserFlyoutVisible = $dyn.observable(false);
                _this.UserFlyoutVisible.valueChanged.subscribe(_this.UserVisible);
                _this.TimeZoneRules.valueChanged.subscribe(_this.updateTimeZoneRules);
                // only fire once
                $.when($dyn.deferred.onTrue(function () {
                    return !!$dyn.value($dyn.value(_this.ProductIsPreview));
                })).done(function () {
                    // delay for 1 second before showing this is done to make sure the labels are loaded
                    window.setTimeout(function () {
                        if ($dyn.util.isPreviewBuild()) {
                            $dyn.shell.ProductShortNameHelpText($dyn.shell.ProductShortNameHelpText() + " " + $dyn.label("Product_IsPreviewDescription"));
                            $dyn.shell.setProductName();
                        }
                    }, 1000);
                });
                _this.ClientFlightInformation.valueChanged.subscribe(_this.updateClientFlight);
                _this.RegionalSettings.valueChanged.subscribe(_this.updateRegionalSettings);
                _this.BrandingLicense.valueChanged.subscribe(_this.updateBrandingNameItems);
                _this.OperatedBy.valueChanged.subscribe(_this.updateOperatedByName);
                // Method that gets overridden in html-binding-telemetry
                _this.recordTelemetry = function () { };
                var navBar = $dyn.ui.getNavBar();
                if (navBar && !$dyn.restrictedNavigation) {
                    // dont load until the initial form is requested
                    $dyn.deferred.onTrue(function () { return $dyn.value($dyn.shell.clientInitialFormRequested); }).done(function () {
                        $dyn.ui.getNavBar().loadNavMenus();
                    });
                }
                _this.Company.valueChanged.subscribe($dyn.DynReact.ModuleStore.reset, $dyn.DynReact.ModuleStore);
                _this.RedirectToDashboard.valueChanged.subscribe(_this.NavigateToDashboard);
                _this.RequestCompanyChange.valueChanged.subscribe(_this.CloseFormsThenChangeCompany);
                _this.RequestedSessionNotFound.valueChanged.subscribe(_this.RestoreServerSession);
                _this.Theme.valueChanged.subscribe($dyn.densityThemeManager._updateThemeAndDensity);
                _this.Density.valueChanged.subscribe($dyn.densityThemeManager._updateThemeAndDensity);
                _this.Startpage.valueChanged.subscribe($dyn.shell.setStartPage);
                _this.NavigationCompanyName = $dyn.computed(function () {
                    var formContext = null;
                    var activeForm = $dyn.shell.getCurrentRootForm();
                    if (activeForm) {
                        formContext = $dyn.context(activeForm);
                    }
                    var navigationCompanyName = "";
                    if (formContext && $dyn.value(formContext.FormSetDefaultCompany)) {
                        navigationCompanyName = formContext.FormCompanyName();
                    }
                    else {
                        navigationCompanyName = _this.CompanyName();
                    }
                    return navigationCompanyName;
                });
                _this.NavigationCompany = $dyn.computed(function () {
                    var formContext = null;
                    var activeForm = $dyn.shell.getCurrentRootForm();
                    if (activeForm) {
                        formContext = $dyn.context(activeForm);
                    }
                    var navigationCompany = "";
                    if (formContext && $dyn.value(formContext.FormSetDefaultCompany)) {
                        navigationCompany = formContext.FormCompany();
                    }
                    else {
                        navigationCompany = _this.Company();
                    }
                    return navigationCompany;
                });
                _this.UserFlyoutVisible.valueChanged.subscribe(function () {
                    if (_this.UserFlyoutVisible()) {
                        // set focus due to unique flyout not on a form element
                        var userFlyoutContainer_1 = $(_this.element).find(".navigationBar-userFlyOut");
                        // we should wait until the active flyout not change
                        $dyn.microTask(function () {
                            var firstFocusableControl = $dyn.util.findFirstFocusableControl(userFlyoutContainer_1);
                            if (firstFocusableControl) {
                                $dyn.log.focus && $dyn.log.focus("Focus: NavBar-> Open user flyout, executing MicroTask to set focus");
                                $(firstFocusableControl).focus();
                            }
                        });
                        _this.recordTelemetry();
                    }
                });
                $.when($dyn.deferred.onTrue(function () {
                    return !!($dyn.value($dyn.user) && $dyn.value($dyn.value($dyn.user).UserName));
                })).done(function () {
                    $dyn.user().setUserAvatar();
                });
                return _this;
            }
            /**
             * Confirm the set company and URL are set to a desired company
             */
            User.prototype.updateCompany = function (newCompany) {
                var _this = this;
                if (newCompany) {
                    if ($dyn.value(this.Company).toLowerCase() !== newCompany.toLowerCase()) {
                        $dyn.async(function () {
                            $dyn.callFunction(_this.SetCompany, undefined, newCompany);
                        }, undefined, "Update company");
                    }
                    else if ($dyn.util.parseQueryString(window.location.search)[$dyn.shell.QueryStringKeys.companyKey.toLowerCase()] !== newCompany.toLowerCase()) {
                        $dyn.shell.updateURLFromUserSettings({ company: newCompany });
                    }
                }
            };
            User.prototype.pack = function () {
                var packed = {
                    ClientFlightInformation: $dyn.value(this.ClientFlightInformation),
                    RegionalSettings: $dyn.value(this.RegionalSettings),
                    TimeZoneRules: $dyn.value(this.TimeZoneRules),
                };
                return packed;
            };
            User.prototype.unpack = function (packed) {
                if (packed) {
                    this.TimeZoneRules(packed.TimeZoneRules);
                    this.RegionalSettings(packed.RegionalSettings);
                    this.ClientFlightInformation(packed.ClientFlightInformation);
                }
            };
            // the command to run a notification action
            User.prototype.executeNotificationAction = function (notificationId) {
                var deferred = $.Deferred();
                $dyn.callFunction(this.ExecuteNotificationAction, undefined, [notificationId], deferred.resolve);
                return deferred.promise();
            };
            // the command to dismiss a notification
            User.prototype.dismissNotification = function (notificationId) {
                $dyn.callFunction(this.DismissNotification, undefined, notificationId);
            };
            User.prototype.setUserAvatar = function () {
                var _this = this;
                var setAvatarAsInitials = function () {
                    var userName = $dyn.value($dyn.user().UserName);
                    if (userName) {
                        var initials = "";
                        var nameSplit = userName.split(" ");
                        var firstName = nameSplit[0];
                        var lastName = nameSplit[1];
                        if (firstName && lastName) {
                            initials = firstName[0] + lastName[0];
                        }
                        else if (firstName) {
                            initials = firstName.substring(0, 2);
                        }
                        else if (lastName) {
                            initials = lastName.substring(0, 2);
                        }
                        _this.UserInitials(initials.toUpperCase());
                        _this.UseAvatarImage(false);
                        _this.UseAvatarInitials(true);
                    }
                    _this.UserAvatarComplete(true);
                };
                setAvatarAsInitials(); // default the users initials
            };
            /**
             * The keydown event handler
             * @param event The keydown event
             */
            User.prototype.keyDown = function (evt) {
                $dyn.util.handleShortcuts(this, evt);
            };
            return User;
        }($dyn.ui.Control));
        controls.User = User;
        // tslint:disable:object-literal-sort-keys
        var userShortcuts = {
            DefaultAction: {
                Keys: { keyCode: [$dyn.ui.KeyCodes.enter, $dyn.ui.KeyCodes.spacebar] },
                Handler: function () {
                    this.Click();
                },
                ShowToUser: false,
            },
        };
        User.prototype.Shortcuts = $dyn.extendPrototype(User.prototype.Shortcuts, userShortcuts);
        $dyn.adapter({ id: "UserButton", controlType: "User", template: "UserButton" });
        // Binding to User is intentional, otherwise we'd have a lot of duplicate code.
        $dyn.adapter({ id: "PopoutUserButton", controlType: "User", template: "PopoutUserButton" });
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=User.js.map
